export default __webpack_public_path__ + "c5016bd5b1f93451dbc741b551908d79.png";